import useModalTabs from "./useModalTabs";

export default function useCloseTabModal<T>() {
    return useModalTabs<T>().closeModal;
}
